/* eslint max-len: 0 */
const icon = require('vue-svgicon')
icon.register({
  'check-light': {
    viewBox: '0 0 24 24',
    data: `<polyline points="7.5 12 10.5 15 16.5 9" style="fill:none;stroke:#000;stroke-miterlimit:10"/>`
  }
})
